module.exports = __webpack_public_path__ + "img/aa.2f9e1d6a.svg";